import { CommonService } from "../../../../../services/CommonService";
import Zones from "../../components/Zone";
import { order } from "../SmartSearchParammeter";

export default async function ZonesConfig(key) {
  let zones = await CommonService.getAllAddressZone();
  return {
    description: "Zone",
    id: "zones",
    initial: [],
    type: order.first,
    handleValues: (searchObject) => {
      searchObject.zones = searchObject.zones.map((z) => z.id);
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Zones
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    operation: ["Must", "Can"],
    list: zones.map((z) => z.description.replace(/,/g, "#").trim()),

    handler: function (searchObj, value) {
      searchObj["zones"] = zones.filter((z) =>
        value.includes(z.description.replace(/#/g, ","))
      );
    }
  };
}
